import { Link } from "react-router-dom";
import { EventPosterImage } from "../../../components/event/eventPosterImage";
import { useWebsiteButton } from "../../../customeHooks/useWebsiteButtons";
import { SingleFindEvent } from "../../../redux/features/event/event.types";
import { getWebsiteEventCardPriceText } from "../../../utils/eventPricing";
import { formatDate } from "../../../utils/helpers";

export const EventCard = ({ event }: { event: SingleFindEvent }) => {
  const { goToEvent } = useWebsiteButton();

  const dateTime = `${formatDate(event.startDate, "ddd, MMM D", true)}${
    event.startTime ? `, ${event.startTime}` : ""
  }`;

  return (
    <Link
      to={event.slug ? goToEvent(event.slug) : "/find-events"}
      className="group flex flex-row items-center gap-4 md:flex-col md:items-start md:gap-4"
    >
      <div className="relative aspect-square w-[89px] shrink-0 overflow-hidden rounded-[6px] bg-[#EDF3FB] md:w-full">
        <EventPosterImage
          image={event.image}
          alt={event.name}
          className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>

      <div className="flex min-w-0 flex-1 flex-col gap-1 md:gap-3">
        <div className="flex flex-col gap-0.5 md:gap-1">
          <p className="line-clamp-2 font-onest text-base font-semibold tracking-[-0.32px] text-ink md:text-xl">
            {event.name}
          </p>
          <p className="font-onest text-sm tracking-[-0.28px] text-[#4f4e4e] md:text-base">
            {dateTime}
          </p>
        </div>
        <p className="font-onest text-sm tracking-[-0.28px] text-[#4f4e4e] md:text-base">
          {getWebsiteEventCardPriceText(event)}
        </p>
      </div>
    </Link>
  );
};
